import React from "react";

const SvgIcnLogout = props => (
  <svg
    id="icn_logout_svg__\u30EC\u30A4\u30E4\u30FC_1"
    data-name="\u30EC\u30A4\u30E4\u30FC 1"
    width={24}
    height={24}
    {...props}
  >
    <defs>
      <style>{".icn_logout_svg__cls-1{fill:#4a4b4c}"}</style>
    </defs>
    <path
      className="icn_logout_svg__cls-1"
      d="M10 23l-8-4V5l8-4v22zM15 9h2V3h-5v2h3v4zM15 19h-3v2h5v-6h-2v4z"
    />
    <path className="icn_logout_svg__cls-1" d="M23 12l-4-4v3h-7v2h7v3l4-4z" />
  </svg>
);

export default SvgIcnLogout;
